import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";
import { getInstanceId } from "./common/serviceUtils";

type RejectFn = (value: string) => unknown;

export const getMainHoursData = async (
  instanceId: string,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  try {
    const response = await awsClientGateway({
      pathTemplate: `/businessHours/${instanceId}?apiName=mainHours`,
      method: "GET",
    });
    return response;
  } catch (error) {
    clientLog({
      component: `mainHours`,
      message: `Something went wrong in getMainHoursData API => ${error}`,
    });
    logMessage(
      `mainHours API`,
      `Something went wrong in getMainHoursData API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in getMainHoursData api endpoint");
  }
};

export const getMainHours = createAsyncThunk<
  unknown,
  void,
  { state: RootState }
>("mainHours/getMainHours", async (_args, { getState, rejectWithValue }) => {
  const instanceId = getInstanceId(getState());
  return await getMainHoursData(instanceId, rejectWithValue);
});

export const createOrUpdateMainHours = createAsyncThunk<
  unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "mainHours/createOrUpdateMainHours",
  async (mainHours, { getState, rejectWithValue }) => {
    try {
      const instanceId = getInstanceId(getState());
      await awsClientGateway({
        pathTemplate: `/businessHours/${instanceId}`,
        method: "POST",
        body: { ...mainHours },
      });
      return await getMainHoursData(instanceId, rejectWithValue);
    } catch (error) {
      clientLog({
        component: `mainHours`,
        message: `Something went wrong in createOrUpdateMainHours API => ${error}`,
      });
      logMessage(
        `mainHours`,
        `Something went wrong in createOrUpdateMainHours API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in createOrUpdateMainHours api endpoint");
    }
  },
);
